module.exports = __webpack_public_path__ + "static/img/ionicons.28df6ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/megamenu/fonts/ionicons.svg
// module id = mE/J
// module chunks = 0